import { useCallback } from "react";

import useCheckForErrors from "global/hooks/useCheckForErrors";
import { ContextValue } from "../types";

export default function useSetErrors(context: ContextValue): ContextValue {
  const { dispatch } = context;

  const setErrors = useCallback(
    function setErrors(errors: string[]) {
      dispatch({
        type: "setErrors",
        payload: {
          errors,
        },
      });
    },
    [dispatch]
  );

  // A function for handling graphql errors
  const onError = useCallback(
    (err) => {
      setErrors([err.message]);
    },
    [setErrors]
  );

  const checkForErrors = useCheckForErrors(setErrors);

  return {
    ...context,
    setErrors,
    checkForErrors,
    onError,
  };
}
